module.exports = __webpack_public_path__ + "static/media/clip_image002.978b9cbc.jpg";